module.exports = __webpack_public_path__ + "static/img/15063B_1_2_C_20220227_LC.21dcd67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15063B_1_2_C_20220227_LC.png
// module id = ZrRX
// module chunks = 0